import { styled } from "sharedUI/styles";

export const OnboardingStyle = styled.div<{ headerChinPadding?: number }>`
    width: 472px;
    padding: 58px 48px;

    hgroup {
        margin-bottom: ${p => p.headerChinPadding ?? 24}px;

        h1 {
            margin-top: 20px;
            font-size: 26px;
            font-weight: 800;
        }
    }

    small {
        font-size: 14px;
        color: ${p => p.theme.textPale};
    }

    .two-fields {
        display: flex;
        justify-content: space-between;
        .field {
            width: 49%;
        }
    }

    .field {
        display: flex;
        flex-direction: column;
        margin: 8px 0 0;
        font-size: 14px;

        label {
            font-weight: 600;
            color: ${p => p.theme.textBase};
        }
    }

    .continue {
        margin-top: 24px;
    }

    .continue button,
    .email-send-button button,
    .invite-link button,
    .skip button {
        cursor: pointer;
        width: 100%;
        margin: 12px 0 0 0;
    }
`;
